const SET_TABLES = (state, tables) => {
  state.tables = tables
}

const SET_COLUMNS = (state, columns) => {
  if (state.table) {
    state.table.columns = columns
  }
}

const SET_TABLE = (state, table) => {
  state.table = table

  if (state.table.source) {
    state.table.source.dossierItems = state.table.source['werkprocessen'].concat(state.table.source['kennisenvaardigheden'])
  }
}

const PUSH = (state, table) => {
  state.tables.push(table)
  state.table = {}
}

const UPDATE = (state, data) => {
  state.tables.find(x => x.id === data.id).name = data.name
}

const REMOVE = (state, tableId) => {
  let idx = state.tables.findIndex(x => x.id === tableId)
  state.tables.splice(idx, 1)
}

const UPDATE_VALUE = (state, params) => {
  let set = state.table.datasets.find(x => x.id === params.setId)
  let column = set.column_values.find(x => x.column_id === params.columnId)

  if (column) {
    column.value_id = params.valueId
  } else {
    set.column_values.push({
      dataset_id: params.setId,
      column_id: params.columnId,
      value_id: params.valueId
    })
  }
}

const RESET = (state) => {
  state.table = null
}

export default {
  PUSH,
  RESET,
  UPDATE,
  REMOVE,
  SET_TABLE,
  SET_TABLES,
  SET_COLUMNS,
  UPDATE_VALUE
}
